import { css, Global }                                                  from '@emotion/react';
import { green, grey }                                                  from '@mui/material/colors';
import CssBaseline                                                      from '@mui/material/CssBaseline';
import { createTheme, StyledEngineProvider, ThemeProvider as Provider } from '@mui/material/styles';
import PropTypes                                                        from 'prop-types';
import LinkBehavior                                                     from '../lib/LinkBehavior';

const UCI = {
  color: {
    primary:   {
      blue:   '#0064a4',
      yellow: '#ffd200',
      black:  '#000',
      white:  '#fff',
    },
    secondary: {
      ltBlue: '#6aa2b8',
      dkBlue: '#1b3d6d',
      ltGray: '#c6beb5',
      dkGray: '#555759',
      yellow: '#f7eb5f',
      orange: '#f78d2d',
      green:  '#7ab800',
    }
  },
  font:  'Helvetica, Arial, Verdana, sans-serif',
};

export const theme = createTheme({
  palette:    {
    primary:   { main: UCI.color.primary.blue },
    secondary: { main: UCI.color.primary.yellow },
    success:   green,
  },
  components: {
    MuiLink:    {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
    },
  }
});

// console.log(theme)


function ThemeProvider ({ children }) {
  return (
    <StyledEngineProvider>
      <CssBaseline />
      <Global styles={css`body { background: ${grey[300]} }`} />
      <Provider theme={theme}>{children}</Provider>
    </StyledEngineProvider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ThemeProvider;
